<template>
  <div>
    <v-container>
      <div class="text-xs-right">
        <span>
          <v-btn
            :loading="exportloading"
            @click="exportData"
            outline
            color="grey"
            class="ma-0 mb-0"
          >
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
          </v-btn>
        </span>
      </div>
      <div class="form-control text-xs-right" style="display: flex">
        <div style="width: 400px; position: relative">
          <input style="padding-right: 40px" @keyup.enter="getData" v-model="search" type="text" />
          <div v-if="search" style="position: absolute; right: 0px; top: 0px">
            <v-btn @click="clearSearch" icon><v-icon>close</v-icon></v-btn>
          </div>
        </div>

        <div>
          <v-btn @click="getData" color="primary" depressed icon><v-icon>search</v-icon></v-btn>
        </div>
      </div>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="data"
        class="elevation-1"
        hide-actions
      >
        <template v-slot:items="props">
          <tr>
            <td class="py-2">
              <v-avatar>
                <v-img :src="props.item.profile_pic"></v-img>
              </v-avatar>
            </td>
            <td>{{ props.item.first_name + ' ' + props.item.last_name }}</td>
            <td>
              <div v-if="projectList(props.item.projectlist).length">
                <v-chip
                  :key="k"
                  v-for="(item, k) in projectList(props.item.projectlist)"
                  small
                  dark
                  color="primary"
                  >{{ item }}</v-chip
                >
              </div>
              <div v-else>ไม่มีโครงการที่สมัคร</div>
            </td>
            <td>{{ props.item.gender }}</td>
            <td>{{ props.item.dob | DateFormat('DD/MM/YYYY') }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.phoneno }}</td>
            <td>{{ getFullAddress(props.item) }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import { mapGetters } from 'vuex'
import * as XLSX from 'xlsx'
export default {
  computed: {
    ...mapGetters(['selectedBot'])
  },
  data() {
    return {
      loading: false,
      exportloading: false,
      data: [],
      search: null,
      headers: [
        { text: '', value: 'profile_pic' },
        { text: 'ชื่อ', value: 'name' },
        { text: 'โครงการที่สมัคร', value: 'projectlist' },
        { text: 'เพศ', value: 'gender' },
        { text: 'วันเกิด', value: 'dob' },
        { text: 'อีเมล', value: 'email' },
        { text: 'เบอร์โทรศัพท์', value: 'phoneno' },
        { text: 'ที่อยู่', value: 'address' }
      ]
    }
  },
  mounted() {
    this.getData()
  },

  methods: {
    clearSearch() {
      this.search = null
      this.getData()
    },
    async exportData() {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      let filename = 'Runner'

      var json = []

      vm.exportloading = true
      // var response = await this.getRunner('export')

      // if (response) {
      //   var data = response
      // }
      var data = this.data
      json = data.map((el) => {
        return {
          ชื่อ: el.first_name ? el.first_name + ' ' + el.last_name : '-',
          โครงการที่สมัคร: el.projectlist ? el.projectlist : '-',
          เพศ: el.gender ? el.gender : '-',
          ที่อยู่: el.dob ? moment(el.dob).format('DD/MM/YYYY') : '-',
          อีเมล: el.email ? el.email : '-',
          เบอร์โทรศัพท์: el.phoneno ? el.phoneno : '-',
          วันที่สมัคร: el.address ? this.getFullAddress(el) : '-'
        }
      })

      var dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
      vm.exportloading = false
    },
    projectList(projectlist) {
      try {
        if (projectlist) {
          return projectlist.split(', ')
        } else {
          return []
        }
      } catch (error) {
        return []
      }
    },
    getFullAddress(item) {
      return `${item.address} จังหวัด${item.province} เขต${item.district} แขวง${item.sub_district} ${item.postcode}`
    },
    getData() {
      this.loading = true
      api.getrunkanmemberdashboard(
        { pageid: this.selectedBot.pageid, search: this.search },
        (err, response) => {
          this.loading = false
          if (response.responsecode == 200) {
            this.data = response.data
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/runkan/Runner.vue